import React, { useState } from "react";
import Styles from "./ForgetPassword.module.css";
import OtpInput from "react-otp-input";
import {
  verifyOTP,
  sendOtpForPasswordUpdate,
} from "../../../Services/ApiCalling/Auth";
import { toast } from "react-toastify";
import { decryptData } from "../../../commons/Decode";

const ForgetPasswordOtp = ({
  username,
  email,
  onOtpVerified,
  onBackToUsername,
}) => {
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [resendTimer, setResendTimer] = useState(0);

  React.useEffect(() => {
    if (resendTimer > 0) {
      const timer = setTimeout(() => setResendTimer(resendTimer - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [resendTimer]);

  const handleVerifyOtp = async () => {
    if (!otp || otp.length !== 6) {
      toast.error("Please enter a valid 6-digit OTP");
      return;
    }

    setLoading(true);
    try {
      const response = await verifyOTP(
        email || username,
        otp,
        "forgetPassword"
      );

      let data = decryptData(response?.data);

      if (data?.code === 200 || data?.success === true) {
        toast.success("OTP verified successfully!");
        onOtpVerified(otp);
      } else {
        const errorMessage = data?.message || "Invalid OTP. Please try again.";

        if (
          errorMessage.toLowerCase().includes("expired") ||
          errorMessage.toLowerCase().includes("expire")
        ) {
          toast.error(errorMessage);
        } else {
          toast.error(errorMessage);
        }
      }
    } catch (error) {
      toast.error("Error verifying OTP");
    } finally {
      setLoading(false);
    }
  };

  const handleResendOtp = async () => {
    if (resendTimer > 0) return;

    setResendLoading(true);
    try {
      const response = await sendOtpForPasswordUpdate(username);

      let data = null;
      if (response?.data) {
        data = decryptData(response.data);
      }

      if (data?.code === 200 || data?.success === true) {
        if (data?.message) {
          toast.success(data.message);
        } else {
          toast.success("OTP sent successfully!");
        }
        setResendTimer(60);
        setOtp("");
      } else {
        const errorMessage =
          data?.error ||
          data?.message ||
          "Failed to resend OTP. Please try again.";
        toast.error(errorMessage);
      }
    } catch (error) {
      let errorMessage = "Failed to resend OTP. Please try again.";
      let errorData = null;

      if (error?.response?.data) {
        errorData = decryptData(error.response.data);
      } else if (error?.data) {
        errorData = decryptData(error.data);
      }

      if (errorData?.error) {
        errorMessage = errorData.error;
      } else if (errorData?.message) {
        errorMessage = errorData.message;
      } else if (error?.message) {
        errorMessage = error.message;
      }

      toast.error(errorMessage);
    } finally {
      setResendLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleVerifyOtp();
    }
  };

  return (
    <div className={Styles.loginContainer}>
      <div className={Styles.loginDisplayContainer}>
        <div className={Styles.loginMainCont}>
          <div className={Styles.loginCompDisplayNameCont}>
            <div className={Styles.compNameText}>GNA Energy</div>
            <div className={Styles.platformText}>Verify OTP</div>
          </div>

          <div className={Styles.loginHeadingCont}>
            <div className={Styles.loginHeadingText}></div>
            <div>
              Please enter the 6-digit OTP sent to your registered email address{" "}
              {email && email !== username && `(${email})`} for{" "}
              <strong>{username}</strong>
            </div>
          </div>

          <div className={Styles.inputMainCOnt}>
            <div className={Styles.loginInputCont}>
              <div className={Styles.loginInputElemCOnt}>Enter OTP</div>
              <div className={Styles.otpInputContainer}>
                <OtpInput
                  value={otp}
                  onChange={setOtp}
                  numInputs={6}
                  separator={<span style={{ margin: "0 5px" }}></span>}
                  inputStyle={{
                    width: "45px",
                    height: "45px",
                    margin: "0 5px",
                    fontSize: "16px",
                    borderRadius: "8px",
                    border: "1px solid #ddd",
                    textAlign: "center",
                    outline: "none",
                  }}
                  focusStyle={{
                    border: "2px solid #007bff",
                    outline: "none",
                  }}
                  renderInput={(props) => (
                    <input {...props} onKeyPress={handleKeyPress} />
                  )}
                />
              </div>
            </div>

            <div
              className={Styles.resendOtpContainer}
              style={{ marginTop: "20px", textAlign: "center" }}
            >
              {resendTimer > 0 ? (
                <span style={{ color: "#666", fontSize: "14px" }}>
                  Resend OTP in {resendTimer} seconds
                </span>
              ) : (
                <button
                  type="button"
                  disabled={resendLoading}
                  onClick={handleResendOtp}
                  style={{
                    background: "none",
                    border: "none",
                    color: "#007bff",
                    cursor: "pointer",
                    textDecoration: "underline",
                    fontSize: "14px",
                  }}
                >
                  {resendLoading ? "Sending..." : "Resend OTP"}
                </button>
              )}
            </div>
          </div>

          <button
            type="button"
            disabled={loading || !otp || otp.length !== 6}
            className={Styles.signinButton}
            onClick={handleVerifyOtp}
          >
            {loading ? "Verifying..." : "Verify OTP"}
          </button>

          <button
            type="button"
            disabled={loading}
            className={Styles.backBtn}
            onClick={onBackToUsername}
          >
            Back
          </button>
        </div>

        <div className={Styles.bottomText}>
          © {new Date().getFullYear()}, <b>GNA Energy</b> Private Limited All
          Rights Reserved
        </div>
      </div>
    </div>
  );
};

export default ForgetPasswordOtp;
